module.exports = "<button type=\"button\" class=\"btn btn-primary\" (click)=\"logout()\">Logout</button>"